// Mock data for Werdi Media website

export const navItems = [
  { label: 'Beranda', href: '/', route: '/' },
  { label: 'Layanan', href: '/#services', route: '/' },
  { label: 'Rilis Musik', href: '/rilis-musik' },
  { label: 'Rilisan', href: '/rilisan' },
  { label: 'Artis', href: '/artis' },
  { label: 'Blog', href: '/blog' },
  { label: 'Kontak', href: '/kontak' },
];

export const stats = [
  { value: '20+', label: 'Digital Music Store' },
  { value: '5.000+', label: 'Lagu Terdistribusi' },
  { value: '1.200+', label: 'Artis Terdaftar' },
  { value: '10 Thn', label: 'Pengalaman' },
];

export const services = [
  {
    icon: 'Music2',
    title: 'Distribusi Musik',
    description:
      'Rilis lagu Anda ke Spotify, Apple Music, JOOX, TikTok, YouTube Music, Amazon Music, Deezer dan 20+ platform digital lainnya di seluruh dunia.',
    features: ['Rilis Cepat 5-7 Hari', 'Royalti 75% Artis', 'Distribusi Worldwide'],
  },
  {
    icon: 'ShieldCheck',
    title: 'Copyright Manager',
    description:
      'Lindungi hak cipta karya musik Anda di YouTube, Facebook, dan Instagram. Kami monitor dan claim setiap penggunaan lagu Anda.',
    features: ['YouTube Content ID', 'Facebook Rights Manager', 'Monetisasi Otomatis'],
  },
  {
    icon: 'BarChart3',
    title: 'Analytics & Royalti',
    description:
      'Dashboard komprehensif untuk memantau performa lagu, streaming, dan royalti dari seluruh platform secara real-time.',
    features: ['Laporan Bulanan', 'Data Streaming Detail', 'Transparansi Penuh'],
  },
  {
    icon: 'Megaphone',
    title: 'Promosi & Marketing',
    description:
      'Bantu karya musik Anda menjangkau pendengar lebih luas dengan strategi promosi digital di berbagai platform sosial media.',
    features: ['Playlist Pitching', 'Social Media Push', 'Editorial Support'],
  },
];

// Rilis Musik page data
export const rilisMusikFeatures = [
  {
    icon: 'UserX',
    title: 'Tanpa Registrasi',
    desc: 'Rilis musik di Werdi Media tidak harus membuat akun, data musik bisa langsung dikirimkan dengan mengisi form Submit Music.',
  },
  {
    icon: 'Tag',
    title: 'Custom Label',
    desc: 'Rilis musik di Werdi Media bisa menggunakan Label mandiri atau menggunakan Label Werdi Media.',
  },
  {
    icon: 'Zap',
    title: 'Proses Cepat',
    desc: 'Dalam 5 hingga 7 hari kerja, musik sudah bisa live di semua DSP (Digital Service Provider) yang bekerjasama dengan Werdi Media.',
  },
  {
    icon: 'ShieldCheck',
    title: 'Bebas YouTube Copyright',
    desc: 'Video YouTube artis bebas dari klaim hak cipta dan copyright sepenuhnya milik Artist. Gunakan Copyright Manager untuk claim/unclaim.',
  },
  {
    icon: 'Infinity',
    title: 'Lifetime / Selamanya',
    desc: 'Musik kamu akan live selamanya di DSP yang bekerjasama dengan Werdi Media. Tidak ada biaya bulanan atau tahunan.',
  },
  {
    icon: 'Globe',
    title: 'Worldwide Distribution',
    desc: 'Distribusi ke 20+ DSP di seluruh dunia: Spotify, Apple Music, YouTube Music, TikTok, JOOX, Deezer, Amazon Music, dll.',
  },
];

export const rilisMusikProcess = [
  {
    step: '01',
    title: 'Persiapan',
    desc: 'Siapkan file audio WAV/FLAC (44.1kHz/48kHz - 16bit/24bit) dan Artwork/Cover minimal 1440×1440 pixel (kotak).',
  },
  {
    step: '02',
    title: 'Kirim Data',
    desc: 'Klik tombol Submit Music dan isi kelengkapan sesuai data musik atau lagu kamu.',
  },
  {
    step: '03',
    title: 'Verifikasi & Validasi',
    desc: 'Tim Werdi Media akan mengecek data. Hasil verifikasi dikirim via email & WhatsApp.',
  },
  {
    step: '04',
    title: 'Live di DSP',
    desc: 'Setelah lolos verifikasi, lagu Anda akan live di seluruh platform Digital Music Store partner kami.',
  },
];

export const rilisMusikBenefits = [
  { label: 'Biaya Distribusi', value: 'GRATIS' },
  { label: 'Hak Cipta', value: '100% Artis' },
  { label: 'Royalti', value: '75% Artis' },
  { label: 'YouTube Content ID', value: 'Included' },
  { label: 'Proses', value: '5-7 Hari Kerja' },
  { label: 'Label', value: 'Werdi Media / Mandiri' },
];

export const recentReleases = [
  { title: 'Pekpek Upe', artist: 'Eva Valentine', date: 'Jul 4, 2025' },
  { title: 'Tangisan Anak Yatim', artist: 'Nanda Ardiansta', date: 'Jul 3, 2025' },
  { title: "She's too Special", artist: 'TheBigBoy', date: 'Jul 2, 2025' },
  { title: 'Tresna Hilang', artist: 'Diva Ucik', date: 'Jul 1, 2025' },
  { title: 'Mananti Manabuih Janji', artist: 'Nanda Ardiansta feat. Yolanda Cemara', date: 'Jun 26, 2025' },
  { title: 'Palsu', artist: 'Nadya, Zaskia N Friends', date: 'Jun 22, 2025' },
];

export const partners = [
  { name: 'Spotify', icon: 'spotify' },
  { name: 'Apple Music', icon: 'apple' },
  { name: 'YouTube Music', icon: 'youtube' },
  { name: 'Amazon Music', icon: 'amazon' },
  { name: 'TikTok', icon: 'tiktok' },
  { name: 'JOOX', icon: 'joox' },
  { name: 'Deezer', icon: 'deezer' },
  { name: 'Resso', icon: 'resso' },
  { name: 'iTunes', icon: 'itunes' },
  { name: 'Yandex Music', icon: 'yandex' },
  { name: 'Langit Musik', icon: 'langit' },
  { name: 'Facebook', icon: 'facebook' },
  { name: 'Instagram', icon: 'instagram' },
  { name: 'Pandora', icon: 'pandora' },
];

export const testimonials = [
  {
    name: 'DAY IDAY',
    role: 'Recording Artist',
    quote:
      'Werdi Media benar-benar membantu karier musik saya. Proses distribusi cepat dan royalti selalu tepat waktu.',
    rating: 5,
  },
  {
    name: 'Uchi Qolby',
    role: 'Solo Vocalist',
    quote:
      'Layanan copyright manager mereka sangat membantu melindungi karya kami di YouTube dan Facebook.',
    rating: 5,
  },
  {
    name: 'Bayuga',
    role: 'Grup Musik',
    quote:
      'Tim yang responsif, profesional, dan benar-benar peduli dengan musisi. Recommended sekali!',
    rating: 5,
  },
];

export const faqs = [
  {
    q: 'Berapa lama proses distribusi musik?',
    a: 'Proses distribusi biasanya memakan waktu 5-7 hari kerja untuk seluruh platform digital music store worldwide.',
  },
  {
    q: 'Berapa persen royalti yang diterima artis?',
    a: 'Artis mendapat 75% royalti dari streaming dan penjualan digital. Hak cipta sepenuhnya (100%) milik artis.',
  },
  {
    q: 'Platform apa saja yang tercover?',
    a: 'Kami mendistribusikan ke Spotify, Apple Music, YouTube Music, JOOX, TikTok, Amazon Music, Deezer, Resso, Langit Musik dan 20+ platform lainnya.',
  },
  {
    q: 'Apakah ada biaya distribusi?',
    a: 'Tidak. Distribusi musik di Werdi Media GRATIS selamanya. Tidak ada biaya bulanan maupun tahunan.',
  },
  {
    q: 'Bagaimana cara melindungi hak cipta lagu saya?',
    a: 'Kami menyediakan layanan Copyright Manager yang mengintegrasikan lagu Anda ke YouTube Content ID dan Facebook Rights Manager untuk monitoring dan monetisasi otomatis.',
  },
  {
    q: 'Apakah saya perlu ISRC atau UPC code?',
    a: 'Tidak perlu. Werdi Media akan menyediakan ISRC dan UPC code secara gratis untuk setiap rilisan Anda.',
  },
  {
    q: 'Bisa menggunakan label sendiri?',
    a: 'Ya, Anda bisa menggunakan label mandiri atau menggunakan label Werdi Media.',
  },
];

export const footerLinks = {
  layanan: [
    { label: 'Rilis Musik', href: '/rilis-musik' },
    { label: 'Copyright Manager', href: '/#services' },
    { label: 'Analytics', href: '/#services' },
    { label: 'Promosi', href: '/#services' },
  ],
  perusahaan: [
    { label: 'Rilisan', href: '/rilisan' },
    { label: 'Blog', href: '/blog' },
    { label: 'Tentang Kami', href: '/#about' },
    { label: 'Partner', href: '/#partners' },
  ],
  bantuan: [
    { label: 'FAQ', href: '/#faq' },
    { label: 'Kontak', href: '/kontak' },
    { label: 'Member Area', href: 'https://member.werdimedia.com' },
    { label: 'Kebijakan Privasi', href: '#' },
  ],
};
